module.exports = __webpack_public_path__ + "img/ncb-gongjing-2020.5803b7e6.png";